import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import {
  IconButton,
  Badge,
  Typography,
  Avatar,
  Tooltip,
  Popover,
  MenuList,
  MenuItem,
  Paper,
  ClickAwayListener
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import NotificationsIcon from '@material-ui/icons/Notifications';
import { PROFILE, LAWYERS_CONTACTED, CLIENT_ACCOUNT } from '../../../routes/';
import { useHistory } from "react-router-dom";
import { doSignOut } from '../../../configs/environments/firebase/firebaseApp';
import Popup from '../../Modal/PopUp';
const maleAvatar = '/img/avatars/avatares-cuadro-h.svg';
const femaleAvatar = '/img/avatars/avatares-cuadro-m.svg';
const lawFirmAvatar = '/img/avatars/avatares-cuadro-logo.svg';
const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    marginRight: theme.spacing(2),
  },
  marginRight: {
    marginRight: theme.spacing(2),
    color: 'white',
    fontSize: 14
  },
  title: {
    flexGrow: 1,
  },
  avatar: {
    cursor: 'pointer',
    width: 40,
    height: 40,
    marginRight: 8,
    backgroundColor: 'white'
  },
  avatarPremium: {
    cursor: 'pointer',
    width: 40,
    height: 40,
    marginRight: 8,
    backgroundColor: 'white',
    border: '1px solid rgb(142, 117, 39)',
  },
  avatarLetters: {
    backgroundColor: 'white',
    color: '#10587f',
    fontSize: 18,
    cursor: 'pointer',
    width: 40,
    height: 40,
    marginRight: 8,
  },
  inBar: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    margin: '0 auto',
    padding: 0,
  },
  inDrawer: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    margin: '0 auto',
    padding: 0,
    flexFlow: 'row-reverse',
    justifyContent: 'flex-end'
  },
  colorBlue: {
    color: '#013957',
    fontSize: 14,
    //borderLeft: 0,
  },
  username: {
    color: 'white',
    fontSize: 14,
    marginRight: 18,
    paddingLeft: 24,
    borderLeft: '1px solid white',
  },
  bell: {
    color: 'white',
    fontSize: 14,
    marginRight: 12,
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paperModal: {
    display: 'flex',
    flexDirection: 'Column',
    maxWidth: 464,
    height: 'auto',
    borderRadius: 4,
    margin: 12,
    padding: '12px',
    boxShadow: '0 15px 15px 0 rgba(0, 40, 62, 0.3)',
    backgroundColor: 'white',
    '&:focus': {
      outline: 'none'
    }
  },
  close: {
    display: 'flex',
    justifyContent: 'flex-end',
    cursor: 'pointer'
  },
  infoWrapper: {
    padding: '16px 38px 0',
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'center',
  },
  title: {
    fontSize: 20,
    color: '#10587f',
    textAlign: 'center',
    marginBottom: 16
  },
  subTitle: {
    fontSize: 16,
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    color: '//#endregion484848',
  },
  modalIcon: {
    fontSize: 32,
    padding: '0 8px'
  },
  buttonsContainer: {
    display: 'flex',
    justifyContent: 'space-around',
    flexWrap: 'wrap',
    paddingTop: 18,
    width: '100%',
  },
  notNow: {
    background: 'unset',
    border: 0,
    fontSize: 14,
    fontWeight: 'bold',
    color: '#10587f',
    cursor: 'pointer',
    outline: 'unset'
  },
}));
export default ({
  avatar,
  profile,
  notifications,
  handleOpenMenu,
  inDrawer,
  blueName,
}) => {
  const classes = useStyles();
  const isTablet = useMediaQuery('(max-width:768px)');
  const defaultAvatar =
    profile && profile.role === 'lawyer'
      ? profile.genero === 'male'
        ? maleAvatar
        : femaleAvatar
      : lawFirmAvatar;
  const [open, setOpen] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const anchorRef = useRef(null);
  const handleToggle = () => {
    setOpen(prevOpen => !prevOpen);
  };
  const handleClose = event => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };
  function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    }
  }
  
  const handleOpenModal = (event) => {
    setOpenModal(true);
  };
  const handleCloseModal = () => {
    setOpenModal(false);
  };
  const prevOpen = useRef(open);
  useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }
    prevOpen.current = open;
  }, [open]);
  const history = useHistory();

  const handleSignOut = (event) => {
    event.preventDefault()
    doSignOut().then(res => {
      history.push('/usuario')
    })
  }

  const handleContactedLawyers = () => {
    history.push(LAWYERS_CONTACTED)
    setOpen(false);
  }

  const handleAccountClient = () => {
    history.push(CLIENT_ACCOUNT)
    setOpen(false);
  }

  let membershipType = ''
  if (profile && profile.membership && profile.membership.type) {
    membershipType = profile.membership.type
  }

  return (
    <>
      <Popup
        open={openModal}
        handleClose={handleCloseModal}
        title='¿Quieres salir de tu sesión?'
        subtitle='Tendrás que volver a iniciar sesión para ingresar.'
        primaryButton={true}
        primaryButtonVariant='primarySolidOutlined'
        primaryButtonText='Sí, salir'
        primaryFunction={handleSignOut}
        secondaryButton={true}
        secondaryButtonVariant='primary'
      />
      <div
        className={inDrawer ? classes.inDrawer : classes.inBar}
      >
        <>
          {!inDrawer && (
            <IconButton
              aria-label="notifications"
              className={classes.bell}
              //onClick={handleOpenMenu}
              onClick={() => {
                profile && profile.role === 'cliente' ? history.push('/notificaciones') : history.push('/dashboard/notificaciones')
              }}
            >
              <Badge
                badgeContent={
                  profile.notificationsLaw &&
                  profile.notificationsLaw.filter((n) => !n.read).length}
                max={99}
                color="error"
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              >
                <NotificationsIcon />
              </Badge>
            </IconButton>
          )}

          {profile ?
            (profile.role === 'lawyer' || profile.role === 'lawFirm' ?
            (
              <Typography className={blueName ? classes.colorBlue : inDrawer? classes.marginRight : classes.username}>
              {profile && profile.role === 'lawyer' ? (profile.name + " " + profile.firstLastName) : (profile && profile.officeName ? profile.officeName : '')}
              </Typography>

            ):
            (
            <Typography className={blueName ? classes.colorBlue : inDrawer? classes.marginRight : classes.username}>
              {profile && profile.role === 'cliente' && profile.registeredSocial ?
                (profile.displayName && profile.displayName) :

              (profile && profile.role === 'cliente' && profile.name ?
              (`${profile.name} ${profile.lastName}`) :
              
              (!profile.registeredSocial && profile.additionalUserInfo.profile.name ?

              (profile.name ?
                `${profile.name} ${profile.lastName}` :
                `${profile.additionalUserInfo && profile.additionalUserInfo.profile.name}`
              )
                :
                ('')))
              }
            </Typography>)): null
          }

{/* <Typography className={blueName ? classes.colorBlue : inDrawer? classes.marginRight : classes.username}>
              {profile && profile.role === 'lawyer' ? (profile.name + " " + profile.firstLastName) : (profile && profile.officeName ? profile.officeName : '')}
              {profile && profile.role === 'cliente' && profile.registeredSocial ?
                (profile.displayName && profile.displayName) :

              (profile && profile.role === 'cliente' && profile.name ?
              (`${profile.name} ${profile.lastName}`) :
              
              (profile && profile.role === 'cliente' && !profile.registeredSocial && profile.additionalUserInfo.profile.name ?

              (profile.name ?
                `${profile.name} ${profile.lastName}` :
                `${profile.additionalUserInfo && profile.additionalUserInfo.profile.name}`
              )

                :

                (profile && profile.role === 'cliente' && '')))
              }
            </Typography> :
            null */}

          {
            (profile && profile.role === 'lawyer') || (profile && profile.role === 'lawFirm') ?
              (<Tooltip
                title="Ir a Mi Perfil"
                aria-label="Ir a Mi Perfil"
                placement="bottom"
              >
                {/* ES ESTE AVATAR */}
                <Link to={PROFILE} style={{ textDecoration: 'none' }}>
                  {profile && profile.imgProfile ?
                    <Avatar
                      alt={profile && profile.role === 'lawyer' ? profile.name + " " + profile.firstLastName : profile && profile.officeName ? profile.officeName : ''}
                      src={profile.imgProfile}
                      className={
                        membershipType === 'Premium' ?
                        classes.avatarPremium :
                        classes.avatar
                      }
                    /> :
                    <Avatar
                      alt={profile && profile.role === 'lawyer' ? profile.name + " " + profile.firstLastName : profile && profile.officeName ? profile.officeName : ''}
                      src={avatar ? avatar : defaultAvatar}
                      className={
                        membershipType === 'Premium' ?
                        classes.avatarPremium :
                        classes.avatar
                      }
                    />
                  }
                </Link>
              </Tooltip>
              ) : null
          }
          {
            profile && profile.role === 'cliente' ?
              (
                <>
                  <Popover open={open} anchorEl={anchorRef.current} anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                  }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'right',
                    }}>
                    <Paper>
                      <ClickAwayListener onClickAway={handleClose}>
                        <MenuList autoFocusItem={open} id="menu-list-grow" onKeyDown={handleListKeyDown}>
                        <MenuItem onClick={handleContactedLawyers}>Contactos guardados</MenuItem>
                          <MenuItem style={{ border: 'solid 1px #e7e7e7 ' }} onClick={handleAccountClient}>Mi cuenta</MenuItem>
                          <MenuItem onClick={handleOpenModal}>Cerrar sesión</MenuItem>
                        </MenuList>
                      </ClickAwayListener>
                    </Paper>
                  </Popover>
                 {/* {profile && profile.imgProfile ? ( */}
                  {profile && profile.registeredSocial ? 
                    ( profile.registeredSocial ? 
                      (<Avatar
                        ref={anchorRef}
                        aria-controls={open ? 'menu-list-grow' : undefined}
                        aria-haspopup="true"
                        onClick={handleToggle}
                        alt={profile.displayName}
                        src={profile.user.photoURL }
                        className={classes.avatarLetters}
                      />)
                        :
                      (<Avatar
                        ref={anchorRef}
                        aria-controls={open ? 'menu-list-grow' : undefined}
                        aria-haspopup="true"
                        onClick={handleToggle}
                        alt={profile.displayName}
                        src={defaultAvatar}
                        className={classes.avatarLetters}
                      />)
                    )
                    :
                    (<Avatar
                      ref={anchorRef}
                      aria-controls={open ? 'menu-list-grow' : undefined}
                      aria-haspopup="true"
                      onClick={handleToggle}
                      alt={profile.name + " " + profile.lastName}
                      className={classes.avatarLetters}
                    >{profile.name.charAt(0) + profile.lastName.charAt(0)}</Avatar>) }                 
                </>
              ) : ('')
          }
          {profile &&  !profile.registeredSocial && profile.additionalUserInfo ?
              (
                <>
                  <Popover open={open} anchorEl={anchorRef.current} anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                  }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'right',
                    }}>
                    <Paper>
                      <ClickAwayListener onClickAway={handleClose}>
                        <MenuList autoFocusItem={open} id="menu-list-grow" onKeyDown={handleListKeyDown}>
                        <MenuItem onClick={handleContactedLawyers}>Contactos guardados</MenuItem>
                          <MenuItem style={{ border: 'solid 1px #e7e7e7 ' }} onClick={handleAccountClient}>Mi cuenta</MenuItem>
                          <MenuItem onClick={handleOpenModal}>Cerrar sesión</MenuItem>
                        </MenuList>
                      </ClickAwayListener>
                    </Paper>
                  </Popover>
                 {!profile.registeredSocial && profile.additionalUserInfo.profile.picture ?
                    (<Avatar
                      ref={anchorRef}
                      aria-controls={open ? 'menu-list-grow' : undefined}
                      aria-haspopup="true"
                      onClick={handleToggle}
                      alt={profile.user.displayName}
                      src={profile.additionalUserInfo.profile.picture}
                      className={classes.avatarLetters}
                    />)
                  :
                  null
                 }                
                </>
              ) : ('')
          }
        </>
      </div>
    </>
  );
};